module.exports = __webpack_public_path__ + "img/bix.47583579.svg";